module.exports = __webpack_public_path__ + "img/ico-privacy-close.aedf99bb.svg";